import axios from "axios";
import { endpoint } from "../../config";
import { customToast } from "../../lib/toastLib";

const reportAuthTokenApi = async () => {
  try {
    const apiLink = `${endpoint}/api/visualization/report-auth-token`;
    const response = await axios.get(apiLink);
    const data = response.data;

    return data.token;
  } catch (error) {
    if (error.response) {
      customToast.error(error.response.data?.message);
    } else {
      customToast.error(error.message);
    }
    throw error;
  }
};

export default reportAuthTokenApi;
